/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doctor-availability-slot.reducer';

export const DoctorAvailabilitySlotDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const doctorAvailabilitySlotEntity = useAppSelector(state => state.doctorAvailabilitySlot.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doctorAvailabilitySlotDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.doctorAvailabilitySlot.detail.title">DoctorAvailabilitySlot</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.doctorAvailabilitySlot.id">Id</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilitySlotEntity.id}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.doctorAvailabilitySlot.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilitySlotEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.doctorAvailabilitySlot.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilitySlotEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.doctorAvailabilitySlot.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilitySlotEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.doctorAvailabilitySlot.active">Active</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilitySlotEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.doctorAvailabilitySlot.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilitySlotEntity.cursor}</dd>
          <dt>
            <span id="startTime">
              <Translate contentKey="tinyMedicRestApp.doctorAvailabilitySlot.startTime">Start Time</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilitySlotEntity.startTime}</dd>
          <dt>
            <span id="endTime">
              <Translate contentKey="tinyMedicRestApp.doctorAvailabilitySlot.endTime">End Time</Translate>
            </span>
          </dt>
          <dd>{doctorAvailabilitySlotEntity.endTime}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorAvailabilitySlot.availability">Availability</Translate>
          </dt>
          <dd>{doctorAvailabilitySlotEntity.availability ? doctorAvailabilitySlotEntity.availability.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/doctor-availability-slot" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doctor-availability-slot/${doctorAvailabilitySlotEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoctorAvailabilitySlotDetail;
